import React from 'react'

export interface BulkSelectionBarProps {
  count: number
  onApprove?: () => void
  onReject?: () => void
  onMakePublic?: () => void
  onMakePrivate?: () => void
  onClear?: () => void
}

export default function BulkSelectionBar(props: BulkSelectionBarProps) {
  if (props.count === 0) return null
  // TODO: Wire to bulk API mutations and show progress/disabled states
  // - [ ] Confirm dialogs for destructive actions
  // - [ ] Error toasts on failure; success snackbars
  // - [ ] i18n-ready labels
  return (
    <div className="sticky bottom-0 inset-x-0 bg-background border-t p-3 flex items-center gap-2 z-10">
      <div className="text-sm">{props.count} selected</div>
      <div className="flex gap-2 ml-auto">
        {props.onApprove && <button className="btn btn-sm" onClick={props.onApprove}>Approve</button>}
        {props.onReject && <button className="btn btn-sm" onClick={props.onReject}>Reject</button>}
        {props.onMakePublic && <button className="btn btn-sm" onClick={props.onMakePublic}>Make Public</button>}
        {props.onMakePrivate && <button className="btn btn-sm" onClick={props.onMakePrivate}>Make Private</button>}
        {props.onClear && <button className="btn btn-sm" onClick={props.onClear}>Clear</button>}
      </div>
    </div>
  )
}
